import genericAvatar from "assets/images/generic_avatar.jpg";
import { ErrorModal, PageContainer } from "components";
import { resetToggles } from "components/Navigation";
import { StudentTeacherSecondaryInfo } from "components/reusables";
import { AddEditStudentTeacherModal } from "components/reusables/AddEditModals/AddEditStudentTeacherModal";
import React, { useCallback, useState } from "react";
import { useAsync } from "react-async";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import Img from "react-cool-img";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { getStudentTeacherStory } from "services";
import { generateFullName, URLPaths } from "utilities";

export function PopoverStudentTeacherDetails(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [isShowingEditTeacherModal, setIsShowingEditTeacherModal] = useState(false);
  const promiseFn = useCallback(() => getStudentTeacherStory(id), [id]);
  const { data, error, isPending } = useAsync({ promiseFn });
  const teacher = data;
  const history = useHistory();

  const handleClick = () => {
    history.push("/map");
    resetToggles();
  };

  if (!teacher && !isPending) return <Redirect to={URLPaths.map} />;

  return (
    <>
      <PageContainer>
        <div>
          {isPending ? (
            <Spinner animation="border" />
          ) : (
            teacher && (
              <Row>
                <Col xs={3}>
                  <Img
                    src={teacher.photoUrl || ""}
                    placeholder={genericAvatar}
                    alt={`${teacher.firstName} ${teacher.lastName}`}
                    width="100%"
                    loading="lazy"
                    className="img-circle"
                  />
                  <hr />
                  <StudentTeacherSecondaryInfo studentTeacher={teacher} direction="column" />
                  {/* <hr />
                  <StudentTeacherContactInfo teacher={teacher} /> */}
                </Col>
                <Col>
                  <Row>
                    <Col>
                      <h1>
                        {generateFullName(teacher.firstName, teacher.lastName)} (Student-Teacher){" "}
                      </h1>
                      <span>{`Class of ${teacher.gradYear}`}</span>
                    </Col>

                    <Col xs="auto">
                      <Button onClick={handleClick} variant="outline-danger">
                        Go Back
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    {/* Sue doesn't want a bio section. This will move the quotes to the center as well
                    <Col xs={8}>
                      <h4>About</h4>
                      <p className="p-breaks">{teacher.bio}</p>
                    </Col> */}
                    <Col xs={10}>
                      {(teacher.quotes || []).length > 0 && (
                        <>
                          <h4>Quotes</h4>
                          <Card className="quotes">
                            <Card.Body>
                              {teacher.quotes?.map(quote => (
                                <AlumQuote key={quote} quote={quote} />
                              ))}
                            </Card.Body>
                          </Card>
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
          )}
          <ErrorModal error={error} />
        </div>
      </PageContainer>
      {!!teacher && (
        <AddEditStudentTeacherModal
          show={isShowingEditTeacherModal}
          setShow={setIsShowingEditTeacherModal}
          currentTeacher={teacher}
        />
      )}
    </>
  );
}

interface AlumQuoteProps {
  quote: string;
}

function AlumQuote({ quote }: AlumQuoteProps): JSX.Element {
  return (
    <div className="quote d-flex flex-row">
      <span>&quot;{quote}&quot;</span>
    </div>
  );
}
